import { FunctionComponent } from 'react'

import { RootStackScreenComponentProps } from 'src/navigation'

export const PREMIO_PLUS_URL =
  'https://www.santander.com.br/hotsite/santanderfinanciamentos/premio-mais.html#premio-mais-regulamento'

export type PremioPlusScreenComponent = FunctionComponent<PremioPlusScreenProps>

export type PremioPlusScreenProps = RootStackScreenComponentProps<'PremioPlus'>

export type ResponsivePremioPlusScreenComponent = FunctionComponent<ReturnType<UsePremioPlusScreen>>

export type UsePremioPlusScreen = () => {
  isMobile: boolean
  url: string
}
